import React, {useState} from "react";

import {useFeedbackTools} from "../FeedbackTools";
import {FadeInOverlayBox, OverlayBox, OverlayContainer} from "../OverlayBox";

import Avatar from "@mui/material/Avatar"
import CircularProgress from "@mui/material/CircularProgress"
import ButtonBase from "@mui/material/ButtonBase";
import PhotoCameraIcon from "@mui/icons-material/PhotoCamera";


const AvatarWithUpload = (props) => {
    const {imgSrc, imgAlt, width, height, children, onUpdate, variant="circular"} = props;
    const [isImgLoading, setIsImgLoading] = useState(false);
    const {showErrorNotification, showSuccessNotification} = useFeedbackTools();

    const handelIconChange = async (event) => {
        setIsImgLoading(true);
        try{
            await onUpdate(event.target.files[0]);
            showSuccessNotification("Aggiornamento effettuato");
        }
        catch (e) {
            showErrorNotification(e)
        }
        setIsImgLoading(false);
    }

    return <OverlayContainer>
        <Avatar alt={imgAlt} src={imgSrc} sx={{width: width, height: height}} variant={variant}>
            {children}
        </Avatar>
        {
            !isImgLoading &&
            <FadeInOverlayBox>
                <ButtonBase component='label' sx={{width: "100%", height: "100%"}}>
                    <Avatar sx={{width: "100%", height: "100%", bgcolor: 'rgba(0, 0, 0, 0.6)'}} variant={variant}>
                        <PhotoCameraIcon/>
                    </Avatar>
                    <input type='file' hidden accept="image/*" onChange={handelIconChange}/>
                </ButtonBase>
            </FadeInOverlayBox>
        }
        {
            isImgLoading &&
            <OverlayBox>
                <Avatar sx={{width: "100%", height: "100%", bgcolor: 'rgba(0, 0, 0, 0.6)'}} variant={variant}>
                    <CircularProgress color='warning'/>
                </Avatar>
            </OverlayBox>
        }

    </OverlayContainer>
}

export default AvatarWithUpload;